import { contentBlocksQuery } from './contentBlocksQuery';

interface StoryCardContentQueryArgs {
  isFeed: boolean;
}

export const storyCardContentQuery = ({ isFeed }: StoryCardContentQueryArgs) => `
  ... on StoryCardThreadContent {
    title
    styles {
      backgroundColor
    }
  }
  ... on StoryCardEditorialContent {
    headline
    sourceName
    subHeadline
    text
    textHTML
    styles {
      backgroundColor
    }
  }
  ... on StoryCardImageContent {
    headline
    sourceName
    subHeadline
    text
    textHTML
    gallery {
      id
      image {
        id
        originalFilename
        url
        averageColor
        rightholder
        status
      }
      title
    }
    styles {
      backgroundColor
    }
  }
  ... on StoryCardAudioContent {
    headline
    sourceName
    subHeadline
    text
    textHTML
    gallery {
      id
      audio {
        id
        originalFilename
        thumb
        url
        status
      }
      image {
        id
        originalFilename
        url
        averageColor
        rightholder
        status
      }
      title
    }
    styles {
      backgroundColor
    }
  }
  ... on StoryCardVideoContent {
    headline
    sourceName
    subHeadline
    text
    textHTML
    gallery {
      id
      video {
        id
        originalFilename
        thumb
        url
        status
      }
      image {
        id
        originalFilename
        url
        averageColor
        rightholder
        status
      }
      title
    }
    styles {
      backgroundColor
    }
  }
  ... on StoryCardPdfContent {
    headline
    sourceName
    subHeadline
    text
    textHTML
    gallery {
      id
      pdf {
        id
        originalFilename
        thumb
        url
        status
      }
      image {
        id
        originalFilename
        url
        averageColor
        rightholder
        status
      }
      title
    }
    styles {
      backgroundColor
    }
  }
  ... on StoryCardArticleContent {
    abstract
    contentAuthor
    contentReadTime
    gallery {
      id
      image {
        id
        originalFilename
        url
        averageColor
        rightholder
        status
      }
    }
    headline
    sourceName
    styles {
      teaserImageStyle
      backgroundColor
    }
    title
    url
    urlFormatted
  }
  ... on StoryCardQuoteContent {
    gallery {
      id
      image {
        id
        originalFilename
        url
        averageColor
        rightholder
        status
      }
    }
    headline
    quote
    quoteCreated
    quotePerson
    quotePersonHandle
    quotePersonImage {
      id
      url
    }
    quoteSource
    url
    styles {
      backgroundColor
    }
  }
  ... on StoryCardPostContent {
    abstract
    contentAuthor
    contentReadTime
    gallery {
      id
      image {
        id
        originalFilename
        url
        averageColor
        rightholder
        status
      }
    }
    ${!isFeed ? `contentBlocks { ${contentBlocksQuery} }` : ''}
    headline
    sourceName
    styles {
      teaserImageStyle
      backgroundColor
    }
    title
  }
  ... on StoryCardPollContent {
    headline
    text
    allowAnonymous
    multipleVotes
    showVoteResults
    votingTime
    options {
      id
      text
    }
    selectedVoteIds
    totalVotes
    showTotalVotes
    voteResults {
      id
      count
    }
    gallery {
      id
      video {
        id
        originalFilename
        thumb
        url
        status
      }
      image {
        id
        originalFilename
        url
        averageColor
        rightholder
        status
      }
      title
    }
    styles {
      backgroundColor
    }
  }
  ... on StoryCardEventContent {
    headline
    styles {
      backgroundColor
    }
  }
`;
